<dm-modal-v2 [modalHeaderContent]="modalContent" [modalMinHeight]="'150px'" [hasNonOverflowContent]="true">
    <div additionalFooterButtons>
        <button type="button" id="continue" class="fxp-btn fxp-btn--primary dm-btn" (click)="onContinue()">
            Continue
        </button>
    </div>
</dm-modal-v2>